import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { StyleSettings } from "../../styles/StyleSettings";

interface SnMemoBoxProps {
  defaultValue?: any;
  onValueChanged?: (value: string) => void;
  isReadOnly?: boolean;
  isRequired?: boolean;
  isEditable?: boolean;
  inputRef?: any;
  isSearchPanel?: boolean;
  onFocus?: (target: string) => void;
}

const SnMemoBox = React.memo(
  ({
    defaultValue,
    onValueChanged,
    isReadOnly = false,
    isRequired,
    isEditable = true,
    inputRef,
    isSearchPanel = false,
    onFocus,
  }: SnMemoBoxProps) => {
    const [value, setValue] = useState(defaultValue);
    const [borderWidth, setBorderWidth] = useState("1px");
    const [backgroundColor, setBackgroundColor] = useState("#F1F1F1");
    const fetchDefaultValue = async () => {
      try {
        setValue(defaultValue == null ? "" : defaultValue);
      } catch (error: any) {}
    };
    const fetchIsRequired = async () => {
      try {
        if (isRequired) setBorderWidth("2px");
        else setBorderWidth("1px");
      } catch (error: any) {}
    };

    const fetchIsEditable = async () => {
      try {
        if (isEditable) setBackgroundColor("white");
        else setBackgroundColor("#F1F1F1");
      } catch (error: any) {}
    };

    useEffect(() => {
      fetchDefaultValue();
    }, [defaultValue]);

    useEffect(() => {
      fetchIsRequired();
    }, [isRequired]);

    useEffect(() => {
      fetchIsEditable();
    }, [isEditable]);

    const handleBlur = () => {
      if (onValueChanged) {
        onValueChanged(value); // 포커스가 빠졌을 때만 호출
      }
    };

    const handleKeyDown = async (e: React.KeyboardEvent) => {
      if (e.key === "Tab") {
        await (e.target as HTMLInputElement).blur();
        e.preventDefault();
        onFocus && onFocus("next");
      }
    };

    return (
      <div className="h-full" style={{ height: "100%", width: "100%" }}>
        <TextField
          inputRef={inputRef}
          value={value}
          slotProps={{
            input: {
              style: {
                height: "100%",
                fontSize: StyleSettings.font,
                overflow: "auto", // 스크롤 표시
                resize: "none",
              },
            },
          }}
          multiline
          fullWidth={true}
          disabled={isReadOnly}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const inputValue = e.target.value;
            setValue(inputValue);
          }}
          onKeyDown={handleKeyDown}
          onBlur={handleBlur}
          sx={{
            height: "100%",
            backgroundColor: backgroundColor,
            fontSize: StyleSettings.font,
            "& .MuiOutlinedInput-root": {
              height: "100%",
              alignItems: "flex-start",
              "& textarea": {
                height: "100% !important",
                overflow: "auto !important", // 스크롤 표시
              },
              "& fieldset": {
                borderWidth: borderWidth,
              },
              "&:hover fieldset": {
                borderWidth: borderWidth,
              },
              "&.Mui-focused fieldset": {
                borderWidth: borderWidth,
              },
            },
          }}
        />
      </div>
    );
  }
);

export default SnMemoBox;
